module.exports = __webpack_public_path__ + "static/media/mbb_logo_384.9e3475aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mbb_logo_384.png
// module id = 168
// module chunks = 0